import { useState } from 'react';
import { createContainer } from 'unstated-next';

// 状态管理
const useStore = (
    initialState = {
        // 奖牌榜列表
        list: [],
        // 状态栏高度
        statusBarHeight: 0,
        // 是否展示固定头
        showFixedNav: false,
        // nav高度
        navHeight: 0,
        // 分享标题
        shareTitle: '',
        // 分享描述
        shareDesc: '',
        // 分享缩略图
        shareThumbnail: '',
    },
) => {
    const [states, setStates] = useState(initialState);

    const changeStates = newStates => {
        setStates(prevStates => Object.assign({}, prevStates, newStates));
    };

    return { states, changeStates };
};

export const Store = createContainer(useStore);
